<template>
  <div class="stocking--plan__wrapper">
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <div class="plan--info info__wrapper">
        <div class="title">{{ $l('title_label_base_info') || '基本信息' }}</div>

        <el-row :gutter="10">
          <el-col :span="16">
            <el-form-item
              :label="$l('form_label_evgPlanOrderName') || '备货计划名称'"
              prop="evgPlanOrderName"
            >
              <el-input
                v-model="formData.evgPlanOrderName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                maxlength="100"
                show-word-limit
                size="mini"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_planOrderDate') || '计划日期'"
              prop="planOrderDate"
            >
              <el-date-picker
                v-model="formData.planOrderDate"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_planLeaderName') || '计划负责人'"
              prop="planLeaderCode"
            >
              <dict-select
                v-model="formData.planLeaderCode"
                url="/master/common/dict/baseUserSelect"
                :selectedLabel.sync="formData.planLeaderName"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                size="mini"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_beginDeliveryDate') || '计划最早交期'"
              prop="beginDeliveryDate"
            >
              <el-date-picker
                v-model="formData.beginDeliveryDate"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                disabled
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_endDeliveryDate') || '计划最晚交期'"
              prop="endDeliveryDate"
            >
              <el-date-picker
                v-model="formData.endDeliveryDate"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width: 100%"
                disabled
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_salesPersonCode') || '业务'"
              prop="salesPersonCode"
            >
              <dict-select
                v-model="formData.salesPersonCode"
                url="/master/common/dict/baseUserSelect"
                :selectedLabel.sync="formData.salesPersonName"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                size="mini"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_merchandiserCode') || '跟单'"
              prop="merchandiserCode"
            >
              <dict-select
                v-model="formData.merchandiserCode"
                url="/master/common/dict/baseUserSelect"
                :selectedLabel.sync="formData.merchandiserName"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                size="mini"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_ftyPersonCode') || '工厂跟单'"
              prop="ftyPersonCode"
            >
              <dict-select
                v-model="formData.ftyPersonCode"
                url="/master/common/dict/baseUserSelect"
                :selectedLabel.sync="formData.ftyPersonName"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                size="mini"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_ftyLeaderCode') || '工厂负责人'"
              prop="ftyLeaderCode"
            >
              <dict-select
                v-model="formData.ftyLeaderCode"
                url="/master/common/dict/baseUserSelect"
                :selectedLabel.sync="formData.ftyLeaderName"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                size="mini"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="package-scheme--info info__wrapper">
        <div class="title">
          {{ $l('title_label_package_scheme') || '大货包装方案' }}
        </div>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="
                $l('form_label_evgPackingSchemeCode') || '对应大货包装方案'
              "
              prop="evgPackingSchemeCode"
            >
              <dict-select
                v-model="formData.evgPackingSchemeCode"
                url="/ecom/evg/packing/scheme/select"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                @change="onSchemeChange"
                filterable
                clearable
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_platformName') || '出货渠道'"
              prop="platformName"
            >
              <el-input v-model="formData.platformName" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$l('form_label_custName') || '所属客户'"
              prop="custName"
            >
              <el-input v-model="formData.custName" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_regionName') || '货物运抵国'"
              prop="regionName"
            >
              <el-input v-model="formData.regionName" readonly></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_dispatchPort') || '出运港口'"
              prop="dispatchPort"
            >
              <el-input v-model="formData.v_dispatchPort" readonly></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_containerName') || '出运箱型'"
              prop="containerName"
            >
              <el-input v-model="formData.containerName" readonly></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_totCntInContainerQty') || '装柜入数'"
              prop="totCntInContainerQty"
            >
              <el-input
                v-model="formData.v_totCntInContainerQty"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_totUnitInContainerQty') || '装柜产品数'"
              prop="totUnitInContainerQty"
            >
              <el-input
                v-model="formData.v_totUnitInContainerQty"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_totSpecInContainerQty') || '装柜规格数'"
              prop="totSpecInContainerQty"
            >
              <el-input
                v-model="formData.v_totSpecInContainerQty"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_palletItemNo') || '客户产品ITEM号'"
              prop="palletItemNo"
            >
              <el-input v-model="formData.palletItemNo" readonly></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item
              :label="$l('form_label_palletItemName') || '客户产品名称'"
              prop="palletItemName"
            >
              <el-input v-model="formData.palletItemName" readonly></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_palletGrossWeight') || '单托毛重'"
              prop="palletGrossWeight"
            >
              <el-input
                v-model="formData.v_palletGrossWeight"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_palletNetWeight') || '单托净重'"
              prop="palletNetWeight"
            >
              <el-input
                v-model="formData.v_palletNetWeight"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_palletVolumes') || '单托体积'"
              prop="palletVolumes"
            >
              <el-input v-model="formData.v_palletVolumes" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div style="display: flex;justify-content: flex-end;" v-if="!disabled">
        <el-button type="primary" size="small" @click="save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </div>
    </el-form>
    <div class="mt-4" v-if="evgPlanOrderCode">
      <CustPlan
        :evgPlanOrderCode="evgPlanOrderCode"
        :disabled="disabled"
        @refresh="getData"
      />
    </div>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
import CustPlan from '../cust-plan/table'
import { mapActions } from 'vuex'
export default {
  props: {
    evgPlanOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  components: { CustPlan },
  mixins: [EditLoading],
  data() {
    return {
      formData: {},
      schemeFormData: {
        v_palletVolumes: '',
        v_palletNetWeight: '',
        v_palletGrossWeight: '',
        palletItemName: '',
        palletItemNo: '',
        v_totSpecInContainerQty: '',
        v_totUnitInContainerQty: '',
        v_totCntInContainerQty: '',
        containerName: '',
        v_dispatchPort: '',
        regionName: '',
        custName: '',
        platformName: '',
      },
      rules: {
        evgPlanOrderName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        planOrderDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        planLeaderCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        salesPersonCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        merchandiserCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        ftyPersonCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        ftyLeaderCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        evgPackingSchemeCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    async onSchemeChange(val) {
      if (!val) {
        this.formData = Object.assign({}, this.formData, this.schemeFormData)
      } else {
        const res = await this.$api.ecomEvgPackingSchemeDetailApi({
          evgPackingSchemeCode: val,
        })
        const v_totCntInContainerQty =
          res.body.inContainerQty + ' ' + res.body.v_inContainerUnit
        Object.keys(this.schemeFormData).forEach((e) => {
          this.formData[e] = res.body[e]
        })
        this.formData = Object.assign({}, this.formData, {
          v_totCntInContainerQty: v_totCntInContainerQty,
        })
      }
    },
    async getData() {
      if (!this.evgPlanOrderCode) return
      const res = await this.$api
        .ecomEvgPlanOrderDetailApi({ evgPlanOrderCode: this.evgPlanOrderCode })
        .catch(() => null)
      this.formData = res.body
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomEvgPlanOrderSaveApi(this.formData)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status, body } = res || {}
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      if (!this.evgPlanOrderCode) {
        // await this.closeCurPage()
        this.$router.replace({
          name: 'ecom-evgBiz-evgPlanOrder-detail',
          params: { code: body.evgPlanOrderCode, pageType: 'edit' },
          query: { evgPlanOrderNo: body.evgPlanOrderNo },
        })
        return
      }
      this.$emit('reload')
    },
    async closeCurPage() {
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.stocking--plan__wrapper {
  margin-top: 20px;
  .title {
    font-size: 18px;
    color: #101010;
    font-weight: 600;
    margin-bottom: 5px;
  }
  .info__wrapper {
    margin-bottom: 20px;
  }
}
</style>
